module.exports = __webpack_public_path__ + "static/media/create-series.fe7b34a5.svg";